import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const materialLookupNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('materialLookup'),
});
export interface MaterialLookupNodeCfgSchema extends z.infer<typeof materialLookupNodeCfgSchema> {}

export const materialLookupNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            trigger: 'event',
        }),
        outputs: () => ({
            next: 'event',
        }),
    },
    dataSockets: {
        inputs: () => ({
            serialNumber: 'string',
        }),
        outputs: () => ({
            materialId: 'string',
            modelNumber: 'string',
            className: 'string',
        }),
    },
} satisfies NodeSocketCfg<MaterialLookupNodeCfgSchema>;
